import nanobus from "nanobus";
import React, { useEffect, useMemo, useState } from "react";
import Button from "shared/Button";
import Select from "shared/@forms/Select";
import { useQueryParams } from "shared/@hooks/useQueryParams";
import TabActionBar from "shared/TabActionBar";
import select from "shared/@utils/select";
import BSM from "./BSM";
import DigitalDelivery from "./DigitalDelivery";
import MembershipTransactions from "./Membership";
import CCTransactions from "./CCTransactions";
import LocalFunctions from "./LocalFunctions";
import MajorFunctions from "./MajorFunctions";

const sections = {
  bsm: "bsm",
  membership: "membership",
  digital: "digital",
  cctrans: "cctrans",
  localFunctions: "localfunctions",
  majorFunctions: "majorfunctions",
};

export default function ({ iboNumber }) {
  const query = useQueryParams();

  const [selected, setSelected] = useState(
    query.get("sales") || sections.membership
  );
  const [isRefreshing, setIsRefreshing] = useState(false);
  const events = useMemo(() => nanobus(), []);

  useEffect(() => {
    events.on("refresh:start", () => {
      setIsRefreshing(true);
    });

    events.on("refresh:end", () => {
      setIsRefreshing(false);
    });
  }, []);

  // Update query param to make transaction type sticky.
  useEffect(() => {
    query.set({ sales: selected });
  }, [selected]);

  return (
    <div>
      <TabActionBar
        style={{
          justifyContent: "space-between",
        }}
      >
        <Select
          value={selected}
          onChange={(e) => {
            setSelected(e.target.value);
          }}
        >
          <option value={sections.bsm}>BSM</option>
          <option value={sections.cctrans}>CC Transactions</option>
          <option value={sections.digital}>Digital Delivery</option>
          <option value={sections.localFunctions}>Local Functions</option>
          <option value={sections.majorFunctions}>Major Functions</option>
          <option value={sections.membership}>Membership</option>
        </Select>

        <Button
          disabled={isRefreshing}
          onClick={() => {
            events.emit("refresh");
          }}
        >
          Refresh Transactions
        </Button>
      </TabActionBar>

      {select(selected, {
        [sections.membership]: () => (
          <MembershipTransactions iboNumber={iboNumber} events={events} />
        ),
        [sections.digital]: () => (
          <DigitalDelivery iboNumber={iboNumber} events={events} />
        ),
        [sections.cctrans]: () => (
          <CCTransactions iboNumber={iboNumber} events={events} />
        ),
        [sections.bsm]: () => <BSM iboNumber={iboNumber} events={events} />,
        [sections.localFunctions]: () => (
          <LocalFunctions iboNumber={iboNumber} events={events} />
        ),
        [sections.majorFunctions]: () => (
          <MajorFunctions iboNumber={iboNumber} events={events} />
        ),
      })}
    </div>
  );
}
